import { defineComponent as _defineComponent } from 'vue'
import { createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-52391448"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "button-two" }
const _hoisted_2 = { class: "btn-group" }
const _hoisted_3 = /*#__PURE__*/_createTextVNode("拒绝")
const _hoisted_4 = /*#__PURE__*/_createTextVNode("同意")

import { useRouter } from 'vue-router'


export default /*#__PURE__*/_defineComponent({
  props: {
  typeId: {
    type: Number,
    default: 0 //id
  },
  itemId: {
    type: Number,
    default: 0 //id
  }
},
  setup(__props) {

const props = __props

const router = useRouter()


const to_operate = () => {
  router.push('/approval/operate?state=1&typeId=' + props.typeId + '&itemId=' + props.itemId)
}
const to_repulse = () => {
  router.push('/approval/operate?state=2&typeId=' + props.typeId + '&itemId=' + props.itemId)
}

return (_ctx: any,_cache: any) => {
  const _component_van_button = _resolveComponent("van-button")!

  return (_openBlock(), _createElementBlock("div", null, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _createVNode(_component_van_button, {
          type: "default",
          round: "",
          class: "btn-group-button repulse",
          onClick: to_repulse
        }, {
          default: _withCtx(() => [
            _hoisted_3
          ]),
          _: 1
        }),
        _createVNode(_component_van_button, {
          type: "default",
          round: "",
          class: "btn-group-button consent",
          onClick: to_operate
        }, {
          default: _withCtx(() => [
            _hoisted_4
          ]),
          _: 1
        })
      ])
    ])
  ]))
}
}

})